var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconPi(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u5716\\u5C64_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 30 30",
    enableBackground: "new 0 0 30 30",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#A5A5A5",
    d: "M30,23.581749C30,27.1264515,27.1264515,30,23.581749,30H6.418252C2.8735492,30,0,27.1264515,0,23.581749 V6.418252C0,2.8735492,2.8735492,0,6.418252,0H23.581749C27.1264515,0,30,2.8735492,30,6.418252V23.581749z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F9F9F9",
    d: "M8.931695,18.3299885l-0.3439865,3.6854267C8.5072041,22.8779316,8.0381279,23.656786,7.3133855,24.1313 l-0.7109904,0.4655113c-0.753458,0.4933167-1.7443419-0.097374-1.6687531-0.9947834L6.3961782,6.2383733 c0.0415845-0.5139685,0.4708295-0.9098864,0.9864769-0.9098864h5.3550701c3.0232191,0,5.4740229,2.4508033,5.4740229,5.4740224 v0.1221085c0,3.6490498-2.9656696,6.6032009-6.6146917,6.5890026l-1.7581997-0.0068417 C9.3689518,17.5049515,8.9753647,17.862114,8.931695,18.3299885z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A5A5A5",
    d: "M9.6677551,9.4887333l-0.3378315,4.1886015c-0.0218315,0.2706833,0.1919508,0.5024023,0.4635134,0.5024023 h2.1950502c1.5414953,0,2.7911253-1.249629,2.7911253-2.7911253v-0.0528879c0-1.3502121-1.0945635-2.4447756-2.4447756-2.4447756 h-2.0191422C9.9769497,8.8909483,9.6949883,9.1510849,9.6677551,9.4887333z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F9F9F9",
    cx: 22.9679585,
    cy: 8.8909483,
    r: 2.1612666
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F9F9F9",
    d: "M21.0185394,14.5785799c-0.3240261,0.4365091-0.5162563,0.9566908-0.5539494,1.4990129 l-0.5148392,7.4074821c-0.0603333,0.9130001,0.9059448,1.5369167,1.7132282,1.1062183l0.2033234-0.1084766 c0.8335323-0.4447041,1.4130783-1.251503,1.5683937-2.1833897l0.0024872-0.0149307l0.5470791-7.6535645 c0.0588722-0.8924742-0.9270344-1.681879-1.6756725-1.1924744l-0.461277,0.3015499 c-0.2650871,0.1732931-0.4973927,0.3921566-0.686161,0.6464548L21.0185394,14.5785799z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPi);
export default __webpack_public_path__ + "static/media/icon_pi.4a0e0041828801649f10302e0b907f78.svg";
export { ForwardRef as ReactComponent };